import { computed } from 'vue';

import config from '#shared/features/experimentation/config';
import useExperiments from './useExperiments';
import useExperimentsIds from './useExperimentsIds';
import useKillswitches from './useKillswitches';

export default function useExperimentsArms() {
  const experiments = useExperiments();
  const experimentsIds = useExperimentsIds();
  const killswitches = useKillswitches();

  return computed(() =>
    config.reduce((acc, cur) => {
      const { treatment: id, ks, arm } = cur;

      if (!arm) {
        return acc;
      }

      return {
        ...acc,
        [arm]: !!experiments.value[ks] && (Boolean(killswitches.value[arm]) || experimentsIds.value.includes(id)),
      };
    }, {}),
  );
}
